import React from 'react';
import { CssTextField } from 'components/select';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import style from 'pages/user-preferences/style';
import { useRecoilState } from 'recoil';
import { OrderPayload } from 'pages/user-preferences/store';

function FromDate() {
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [open, setOpen] = React.useState(false);
    const minDate = new Date();
    const maxDate = new Date(minDate);
    maxDate?.setMonth(minDate?.getMonth() + 6); // Add 6 months to minDate

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
                inputFormat="yyyy-MM-dd"
                label="From Date *"
                minDate={minDate}
                maxDate={maxDate}
                value={order?.startDate || null}
                data-testid="from-date-picker"
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                onChange={(value) => {
                    setOrder((prevOrder) => ({
                        ...prevOrder,
                        startDate: value,
                    }));
                    setOpen(false);
                }}
                PopperProps={{
                    // Set the desired placement for the Popper element
                    placement: 'top-start',
                    // Set zIndex to ensure the Popper is always on top
                    style: { zIndex: 9999 },
                }}
                renderInput={(params) => <CssTextField {...params} sx={style.textField} placeholder="" data-testid="FromDate" onClick={() => setOpen(true)} />}
            />
        </LocalizationProvider>
    );
}

export default FromDate;
